import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editPassword, getProfile } from '../../services/user';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/thunks/authThunks';

const UserProfile = () => {
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showEditPasswordModal, setShowEditPasswordModal] = useState(false);
  const [warn, setWarn] = useState('');
  const [formData, setFormData] = useState({
      old_password: '',
      new_password: '',
      retype_password: ''
  });

  useEffect(() => {
    const loadUsers = async () => {
      await getProfile(token)
      .then(response=>{
        setUser(response.data.data);
      })
      .catch(error=>{
        if(error.response?.data?.error.toLowerCase()==='invalid token'){
            handleLogout();
        }else{
            swal({
              title: "User Profile",
              text: error.response?.data?.error || error.message,
              icon: "error",
              buttons: true,
            });
        }
      })
    };

    loadUsers();
  }, []);

  const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const changePassword = async ()=>{
    setFormData({
        old_password: '',
        new_password: '',
        retype_password: ''
    });
    setWarn('');
    if(!formData.old_password){
        setWarn('Please type old password');
        return;
    }
    if(!formData.new_password){
        setWarn('Please type new password');
        return;
    }
    if(!formData.retype_password){
        setWarn('Please retype new password');
        return;
    }
    if(formData.new_password!==formData.retype_password){
        setWarn('New & retype password mismatch');
        return;
    }
    if(formData.new_password!==formData.retype_password){
        setWarn("Old & new password can't be same");
        return;
    }
    await editPassword({password: formData.old_password, new_password: formData.retype_password}, token).then(response=>{
      setWarn('');
      setFormData({
        old_password: '',
        new_password: '',
        retype_password: ''
        });
      setShowEditPasswordModal(false); 
      swal({
        title: "Password Updated",
        text: "Password updated successfully!!!",
        icon: "success",
        buttons: true,
        timer: 3000
      });
      setTimeout(()=>{
        handleLogout();
      }, 3000)      
    }).catch(error=>{
      if(error.response?.data?.error.toLowerCase()==='invalid token'){
        handleLogout();
      }else{
        setWarn(error.response?.data?.error || error.message);
      }
    });
  }

  return (
    <div className="p-6 space-y-6 bg-white">
      {user && <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {['first_name', 'last_name', 'email', 'mobile', 'role', 'gender'].map((field) => (
          <div key={field}>
            <label className="block mb-1 capitalize">{field.replace('_', ' ')}</label>
            <input
              type={field === 'password' ? 'password' : 'text'}
              name={field}
              value={user[field]}
              readOnly
              className="w-full border border-gray-300 px-3 py-2 rounded"
            />
          </div>
        ))}         
      </div>}
      {user && <button
            onClick={()=> setShowEditPasswordModal(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition cursor-pointer"
          >
            Change Password
      </button>}
      {showEditPasswordModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Edit Role</h2>
              <button
                className="text-gray-600 hover:text-gray-800 cursor-pointer"
                onClick={() => setShowEditPasswordModal(false)}
              >
                ✕
              </button>
            </div>
            {warn && (
              <div className="bg-red-50 dark:bg-red-900/30 border-l-4 border-red-500 p-4">
                <p className="text-sm text-red-700 dark:text-red-400">{warn}</p>
              </div>
            )}
            {/* Sample editable fields (you can expand this) */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Old Password</label>
              <input
                type="password"
                name="old_password"
                className="w-full border border-gray-300 px-3 py-2 rounded"
                value={formData.old_password}   
                onChange={handleChange}             
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">New Password</label>
              <input
                type="password"
                name="new_password"
                className="w-full border border-gray-300 px-3 py-2 rounded"
                value={formData.new_password}            
                onChange={handleChange}    
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Retype New Password</label>
              <input
                type="password"
                name="retype_password"
                className="w-full border border-gray-300 px-3 py-2 rounded"
                value={formData.retype_password}       
                onChange={handleChange}         
              />
            </div>
            <div className="text-right">
              <button
                onClick={() => setShowEditPasswordModal(false)}
                className="bg-gray-100 text-gray-800 px-4 py-2 rounded mr-2 cursor-pointer"
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 cursor-pointer"
                onClick={changePassword}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserProfile
